module.exports = __webpack_public_path__ + "static/media/down.bf0528c4.svg";